import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { Leasing } from "~/models/Leasing";

const paths = {
	show: "/kt_leasings/:leasing_id"
};
type TLeasingInfo = (leasingId: string | null) => SwrReturnType<Leasing>;
type ReturnType = {
	leasingInfo: TLeasingInfo;
};

export const useKtLeasings = (): ReturnType => {
	const leasingInfo: TLeasingInfo = (leasingId: string | null) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error } = useSWR<Leasing>(
			leasingId === null ? null : paths.show.replace(":leasing_id", leasingId)
		);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate
		};
	};
	return { leasingInfo };
};
